export default "__VITE_ASSET__BmX3eNcu__"